import GameDaySelector from "../components/GameDaySelector";

const getFilterUIConfig: any = (type: string, filters: any) => {
  return {
    uiScheme: {
      classNames: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
      day: {
        "ui:widget": "game-day-selector",
        "ui:options": {
          label: false, // Oculta el título del campo
          filters: filters,
        },        
      }
    },
    widgets: {
      'game-day-selector': GameDaySelector,    
    },
  };
};
export default getFilterUIConfig;
